import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const BestSellerCard = ({ product, cartProduct, index = 0 }) => {
  const { addItem } = useCart();
  const navigate = useNavigate();

  const buyNow = () => {
    addItem(cartProduct || product);
    navigate("/cart");
  };

  return (
    <div
      data-testid={`best-seller-card-${product.id}`}
      className="fade-up flex flex-col bg-[#FAF7F2] border border-[#C6A769]/40 rounded-sm p-9 sm:p-11 shadow-[0_18px_40px_-22px_rgba(110,86,50,0.28)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_56px_-26px_rgba(110,86,50,0.36)]"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <p className="text-[11px] uppercase tracking-[0.24em] text-[#B08F50] mb-5">
        Digital Download
      </p>
      <h3 className="font-serif-display text-3xl leading-tight text-[#4A3F35]">
        {product.name}
      </h3>
      <div className="w-14 h-px bg-[#C6A769] my-6" />
      <p className="text-[15px] leading-relaxed text-[#6b5d50] flex-1">
        {product.description}
      </p>
      <div className="mt-8">
        <p className="font-serif-display text-2xl text-[#C6A769]">${product.price}</p>
        <p className="text-[11px] uppercase tracking-[0.16em] text-[#8A7D71] mt-1">
          One-Time &middot; Instant Download
        </p>
      </div>
      <button
        onClick={buyNow}
        data-testid={`best-seller-buy-${product.id}`}
        className="mt-7 w-full bg-[#C6A769] text-[#4A3F35] py-4 rounded-sm text-sm font-medium uppercase tracking-[0.18em] transition-all duration-300 hover:bg-[#B08F50] hover:scale-[1.02]"
      >
        Buy Now
      </button>
      <p className="text-[11px] text-[#9C8F82] text-center mt-4">
        All digital products. Instant delivery.
      </p>
    </div>
  );
};

export default BestSellerCard;
